import './styles.scss';
import cn from 'classnames';
type TAppTitleProps = {
  title: string;
  className?: string;
  errors?: string;
};
const AppDetailsTitle = ({ title, className, errors }: TAppTitleProps) => {
  return (
    <div className={cn(className, 'app-details-title')}>
      {title}
      <div>{errors && <div className="customError">{errors}</div>} </div>
    </div>
  );
};
export default AppDetailsTitle;
